import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

export type CompleteRequestChoice =
  | 'imagingReport'
  | 'labReport'
  | 'genericReport'
  | 'procedureReport'
  | 'completeDirect';

@Component({
  selector: 'app-complete-request-choice-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatMenuModule],
  template: `
    <h2 mat-dialog-title>Complete Request</h2>
    <div mat-dialog-content>
      <p class="choice-intro">How would you like to complete this request?</p>
      <div class="choice-list">
        <button type="button" mat-button class="choice-button" [matMenuTriggerFor]="reportMenu">
          <mat-icon>description</mat-icon>
          <span class="choice-text">
            <span class="choice-title">Diagnostic Report</span>
            <span class="choice-subtitle">Write an imaging, lab, or generic report</span>
          </span>
          <mat-icon class="choice-chevron">expand_more</mat-icon>
        </button>
        <mat-menu #reportMenu="matMenu">
          <button mat-menu-item (click)="choose('imagingReport')">
            <mat-icon>image</mat-icon>
            <span>Imaging Diagnostic Report</span>
          </button>
          <button mat-menu-item (click)="choose('labReport')">
            <mat-icon>biotech</mat-icon>
            <span>Lab Diagnostic Report</span>
          </button>
          <button mat-menu-item (click)="choose('genericReport')">
            <mat-icon>description</mat-icon>
            <span>Generic Report</span>
          </button>
        </mat-menu>
        <button type="button" mat-button class="choice-button" (click)="choose('procedureReport')">
          <mat-icon>healing</mat-icon>
          <span class="choice-text">
            <span class="choice-title">Procedure Report</span>
            <span class="choice-subtitle">Write and finalize a procedure report</span>
          </span>
        </button>
        <button type="button" mat-button class="choice-button" (click)="choose('completeDirect')">
          <mat-icon>check_circle</mat-icon>
          <span class="choice-text">
            <span class="choice-title">Complete Directly</span>
            <span class="choice-subtitle">Mark the request completed without writing a report</span>
          </span>
        </button>
      </div>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button (click)="cancel()">Cancel</button>
    </div>
  `,
  styles: [`
    .choice-intro { margin: 0 0 12px; }
    .choice-list { display: flex; flex-direction: column; gap: 8px; }
    .choice-button {
      display: flex;
      align-items: center;
      gap: 12px;
      height: auto;
      padding: 12px;
      border: 1px solid rgba(0, 0, 0, 0.12);
      border-radius: 8px;
      text-align: left;
    }
    .choice-text { display: flex; flex-direction: column; flex: 1; }
    .choice-title { font-weight: 500; }
    .choice-subtitle { font-size: 12px; opacity: 0.75; }
    .choice-chevron { margin-left: auto; }
  `]
})
export class CompleteRequestChoiceDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<CompleteRequestChoiceDialogComponent, CompleteRequestChoice | null>);

  choose(choice: CompleteRequestChoice): void {
    this.dialogRef.close(choice);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
